/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Type_Pregnancy_PhysioInputs */

const en_service_type_pregnancy_physio = /** @type {(inputs: Service_Type_Pregnancy_PhysioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pre- and postnatal physio`)
};

const pl_service_type_pregnancy_physio = /** @type {(inputs: Service_Type_Pregnancy_PhysioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fizjoterapia w ciąży i po porodzie`)
};

/**
* | output |
* | --- |
* | "Pre- and postnatal physio" |
*
* @param {Service_Type_Pregnancy_PhysioInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const service_type_pregnancy_physio = /** @type {((inputs?: Service_Type_Pregnancy_PhysioInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Type_Pregnancy_PhysioInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_service_type_pregnancy_physio(inputs)
	return en_service_type_pregnancy_physio(inputs)
});